
let initialState = {
    'Context':'Retail',
    'ContextId': 2
  };
  
  export const appInfoReducer = (state: any = initialState, action: any) => {

      switch (action.type) {
          case 'APP_CONTEXT_SET':
  
             var newState  = {...state};  
             var payload = JSON.parse(action.payload);             
             newState.Context = payload.Context;  
             newState.ContextId = payload.ContextId;
             
             return newState;
      }
  
      return state;
  }